import { createLocalStorageApi } from 'v5/platform/ts/localStorageApi';
import {
  EMPTY_RESOURCE_TYPE_BINDINGS_STORE,
  RESOURCE_TYPE_BINDINGS_STORAGE_KEY,
  resourceTypeBindingsStore$
} from './resource-type-bindings.api.ls.schema';
import { createResourceTypeBindingsApi } from './resource-type-bindings.api.mock';

/**
 * Interim: mock API + localStorage ReadWriteApi.
 * Swap to `createResourceTypeBindingsHttpApi(apiClient)` when the DB API ships.
 */
export const myResourceTypeBindingsApi = createResourceTypeBindingsApi(
  createLocalStorageApi(
    RESOURCE_TYPE_BINDINGS_STORAGE_KEY,
    resourceTypeBindingsStore$.parse,
    EMPTY_RESOURCE_TYPE_BINDINGS_STORE
  )
);
